import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'
import { Module } from './styles'

function MenuModulesSkeletonComponent() {
  const item = Array(3).fill(3)
  return (
    <>
      {item.map((_, index) => (
        <Module key={index}>
          <Skeleton height={15} width={15} circle className="circle" baseColor={colors.palette.neutral500} />
          <div className="content">
            <Skeleton height={30} width="250px" className="title" baseColor={colors.palette.neutral500} />
            <Skeleton height={25} width="100px" baseColor={colors.palette.neutral500} />
          </div>
        </Module>
      ))}
    </>
  )
}

export const MenuModulesSkeleton = memo(MenuModulesSkeletonComponent)
